<template>
  <div>
    <!-- Hero Section Settings -->
    <v-card class="glass-section-card mb-6" elevation="0">
      <v-card-subtitle class="section-header d-flex align-center pb-2">
        <v-icon left color="primary">mdi-image-area</v-icon>
        <span class="text-subtitle-1 font-weight-bold">Hero sekcija</span>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="localSettings.hero_image_url"
              label="URL slike"
              outlined
              dense
              hide-details
              class="qr-input-field"
              placeholder="https://..."
              @input="emitUpdate"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="localSettings.custom_restaurant_name"
              label="Naziv"
              outlined
              dense
              hide-details
              class="qr-input-field"
              placeholder="Naziv restorana"
              @input="emitUpdate"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="localSettings.hero_description"
              label="Opis"
              outlined
              dense
              rows="2"
              hide-details
              class="qr-input-field"
              placeholder="Kratak opis lokacije"
              @input="emitUpdate"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localSettings.hero_text_color"
              label="Boja teksta"
              outlined
              dense
              hide-details
              class="qr-input-field"
              placeholder="#2c3e50"
              @input="emitUpdate"
            >
              <template v-slot:append>
                <input
                  type="color"
                  v-model="localSettings.hero_text_color"
                  style="width: 30px; height: 30px; border: none; cursor: pointer; border-radius: 4px;"
                  @input="emitUpdate"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="localSettings.hero_transparent_background"
              label="Transparentna pozadina"
              dense
              hide-details
              color="primary"
              class="mb-3"
              @change="emitUpdate"
            ></v-checkbox>
            <v-text-field
              v-model="localSettings.hero_background_color"
              label="Pozadinska boja"
              outlined
              dense
              hide-details
              class="qr-input-field"
              placeholder="#ffffff"
              :disabled="localSettings.hero_transparent_background"
              @input="emitUpdate"
            >
              <template v-slot:append>
                <input
                  type="color"
                  v-model="localSettings.hero_background_color"
                  style="width: 30px; height: 30px; border: none; cursor: pointer; border-radius: 4px;"
                  :disabled="localSettings.hero_transparent_background"
                  @input="emitUpdate"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="localSettings.hero_font_family"
              :items="fontOptions"
              label="Font"
              outlined
              dense
              hide-details
              class="qr-input-field"
              @change="emitUpdate"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="localSettings.hero_font_size"
              :items="fontSizeOptions"
              label="Veličina fonta"
              outlined
              dense
              hide-details
              class="qr-input-field"
              @change="emitUpdate"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="localSettings.hero_text_align"
              :items="textAlignOptions"
              label="Poravnanje teksta"
              outlined
              dense
              hide-details
              class="qr-input-field"
              @change="emitUpdate"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="localSettings.show_logo"
              label="Prikaži logo firme"
              dense
              hide-details
              color="primary"
              @change="emitUpdate"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Items and Categories Styling -->
    <v-card class="glass-section-card mb-6" elevation="0">
      <v-card-subtitle class="section-header d-flex align-center pb-2">
        <v-icon left color="primary">mdi-palette</v-icon>
        <span class="text-subtitle-1 font-weight-bold">Stilizacija artikala i kategorija</span>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localSettings.items_primary_color"
              label="Boja stila"
              outlined
              dense
              hide-details
              class="qr-input-field"
              placeholder="#00b3be"
              @input="emitUpdate"
            >
              <template v-slot:append>
                <input
                  type="color"
                  v-model="localSettings.items_primary_color"
                  style="width: 30px; height: 30px; border: none; cursor: pointer; border-radius: 4px;"
                  @input="emitUpdate"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="localSettings.items_font_family"
              :items="fontOptions"
              label="Font"
              outlined
              dense
              hide-details
              class="qr-input-field"
              @change="emitUpdate"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Display Settings Section -->
    <display-settings
      :settings="localSettings"
      @update:settings="updateDisplaySettings"
    ></display-settings>
  </div>
</template>

<script>
import DisplaySettings from './shared/DisplaySettings.vue'

export default {
  name: 'TemplateAikasa',
  components: {
    DisplaySettings
  },
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localSettings: {},
      fontOptions: [
        { text: 'Default', value: '' },
        { text: 'Roboto', value: 'Roboto, sans-serif' },
        { text: 'Open Sans', value: '"Open Sans", sans-serif' },
        { text: 'Lato', value: 'Lato, sans-serif' },
        { text: 'Montserrat', value: 'Montserrat, sans-serif' },
        { text: 'Poppins', value: 'Poppins, sans-serif' },
        { text: 'Playfair Display', value: '"Playfair Display", serif' },
        { text: 'Merriweather', value: 'Merriweather, serif' }
      ],
      fontSizeOptions: [
        { text: 'Mala', value: 'small' },
        { text: 'Srednja', value: 'medium' },
        { text: 'Velika', value: 'large' },
        { text: 'Vrlo velika', value: 'xlarge' }
      ],
      textAlignOptions: [
        { text: 'Lijevo', value: 'left' },
        { text: 'Centar', value: 'center' },
        { text: 'Desno', value: 'right' }
      ]
    }
  },
  watch: {
    settings: {
      handler (newSettings) {
        this.localSettings = { ...newSettings }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitUpdate () {
      this.$emit('update:settings', this.localSettings)
    },
    updateDisplaySettings (displaySettings) {
      // Merge display settings into local settings
      this.localSettings = {
        ...this.localSettings,
        ...displaySettings
      }
      this.emitUpdate()
    }
  }
}
</script>

<style scoped>
/* Reuse parent styles */
</style>
